import { useMemo } from 'react';
import { InfoBanner } from '@ui';
import { getMultiStopCommercialString } from '@lp/features/RoutePlanner/utils';
import { BaseCommercialAviaLegSchemaValues } from '@lp/features/RoutePlanner/components/RouteLegForm/validation';
import { useLegFormContext } from '@lp/features/RoutePlanner/components/RouteLegForm/context/LegFormContext';
import { useRouteDetails } from '@lp/features/RoutePlanner/hooks/useRouteDetails';
import { useRouteLocations } from '@lp/features/RoutePlanner/hooks/useRouteLocations';
import { CommercialFlightAviaLeg, RouteLegTypeEnum } from '@/api/apis/route';
import { useWatchFields } from '@/hooks/useWatchFields';

export const CommercialMultiStopBanner = () => {
  const { routeType } = useLegFormContext();
  const { list } = useRouteLocations();
  const { legs } = useRouteDetails(routeType);
  const { sabreGroupId } = useWatchFields<BaseCommercialAviaLegSchemaValues>(['sabreGroupId'] as const);

  const connectedLegs = useMemo(() => {
    return legs.filter(
      (leg): leg is CommercialFlightAviaLeg =>
        leg.legType === RouteLegTypeEnum.CommercialFlightAviaLeg && leg.sabreGroupId === sabreGroupId,
    );
  }, [legs, sabreGroupId]);

  const multiStopListString = useMemo(() => {
    return getMultiStopCommercialString(connectedLegs, list);
  }, [connectedLegs, list]);

  if (!multiStopListString) return null;

  return (
    <InfoBanner iconType="multiStop">
      <div className="flex gap-2 items-center">
        <span className="text-m-r">This is a part of multi-stop legs.</span>
        <span className="text-m-sb">{multiStopListString}</span>
      </div>
    </InfoBanner>
  );
};
